import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { IPartnerFinSobRow } from '../../model'

import { getActualsRows } from './getActualsRows'
import { getRevenueMeasureField } from './getRevenueMeasureField'
import { getWeightedSob, TFinSobData } from './getWeightedSob'
import { sumMeasure } from './sumMeasure'
import { IRevenueAndSobFigures, TCategoryRowScope } from './types'

const EMPTY_ACTUALS: IRevenueAndSobFigures = {
  sales: null,
  sob: null,
}

interface IParams {
  rows: IPartnerFinSobRow[]
  /** The financial year the tile is showing. Like the plan, actuals reads this same year,
   *  as-is. */
  selectedFYear: number
  actualsType: ActualsValueTypes
  isLocalCurrency: boolean
  category?: string
  categoryRowScope?: TCategoryRowScope
}

/** The tile's actuals column: what the partner has booked so far this year.
 *
 *  Revenue is additive, so it is a plain sum. SOB is a share, so it only rolls up as an average
 *  weighted by the same revenue measure — a big offering's share must count for more than a small
 *  one's. */
export const getRevenueAndSobActuals = ({
  rows,
  selectedFYear,
  actualsType,
  isLocalCurrency,
  category,
  categoryRowScope,
}: IParams): IRevenueAndSobFigures => {
  const measureField = getRevenueMeasureField(actualsType, isLocalCurrency)

  if (measureField === null) {
    return EMPTY_ACTUALS
  }

  const actualsRows = getActualsRows({
    rows,
    selectedFYear,
    category,
    categoryRowScope,
  })

  const rowData = actualsRows.map<TFinSobData>((row) => ({
    sob: row.sob,
    revenue: row[measureField],
  }))

  const totalSales = sumMeasure(actualsRows, measureField)
  const weightedSob = getWeightedSob(rowData)

  return {
    sales: totalSales,
    sob: weightedSob,
  }
}
